import { RefineThemes } from "@refinedev/antd";
import type { ThemeConfig } from "antd";
import { theme as antTheme } from "antd";
import type { ConfigProviderProps } from "antd/es/config-provider";

const defaultToken = antTheme.getDesignToken();
export const theme = {
  ...RefineThemes.Magenta,
  token: {
    borderRadius: 2,
    borderRadiusLG: 6,
    colorPrimary: "#1677FF",
    colorLink: "#1677FF",
    colorSuccess: "#52C41A",
    colorError: "#FF4D4F",
    colorWarning: "#FD8140",
    colorWhite: "#FFFFFF",
    colorText: "#303333",
    fontFamily: "Hiragino Sans, Open Sans, sans-serif",
  },
  components: {
    Button: {
      borderRadius: 2,
    },
    Collapse: {
      contentBg: defaultToken.colorBorderSecondary,
    },
    Alert: {
      withDescriptionPadding: "9px 24px",
    },
    Modal: {
      padding: 24,
      colorBorder: "white",
      lineWidth: 0,
      borderRadiusSM: 2,
    },
    Typography: {
      titleMarginTop: "0.5rem",
      titleMarginBottom: "0",
    },
    Tag: {
      defaultBg: "white",
      colorPrimary: "#1677FF",
      defaultColor: "#1677FF",
      colorBorder: "#1677FF",
    },
    Form: {
      screenLGMax: 500,
      screenLG: 500,
    },
    Input: {
      borderRadius: 2,
    },
    Radio: {
      dotColorDisabled: "#1677FF80",
    },
    Tooltip: {
      colorBgSpotlight: "rgba(0, 0, 0, 0.65)",
    },
    Statistic: {
      fontFamily: "DinCond",
    },
    Menu: {
      itemSelectedBg: "rgba(22, 119, 255, 0.08)",
      itemSelectedColor: "rgba(22, 119, 255, 1)",
      subMenuItemBorderRadius: 0,
      activeBarWidth: 2,
      itemBorderRadius: 0,
      itemMarginInline: 0,
    },
    List: {
      margin: 6,
    },
    Breadcrumb: {
      lastItemColor: "#1677FF",
    },
    Table: {
      rowSelectedBg: "#E6F7FF",
      borderRadiusLG: 0,
    },
  },
} satisfies ThemeConfig;

export const nonPaddingCollapse = {
  components: {
    Collapse: {
      contentPadding: "16px 0",
      contentBg: defaultToken.colorBorderSecondary,
    },
  },
} satisfies ThemeConfig;

export const formConfig = {
  validateMessages: {
    required: "${label}は必須です。",
    string: {
      max: "最大${max}桁のキャラクタのみ",
    },
    types: {
      email: "${label}の形式が正しくありません。",
    },
  },
} satisfies ConfigProviderProps["form"];
